<template>
	<el-input class="search-input" :placeholder="label" icon="search" :class="{ 'searching': searching }"
		:value="searchTerm" :maxlength="255" @input="updateSearchTerm">
		<span v-if="searchTerm" slot="append" class="search-input-reset" @click="resetSearchTerm">&times;</span>
	</el-input>
</template>

<script>
export default {
	props: {
		label: {
			required: true,
			type: String
		},
		initValue: {
			type: String
		},
		searching: {
			type: Boolean
		}
	},

	data() {
		return {
			searchTerm: this.initValue
		}
	},

	created() {
		// Set a new timer to emit the input event after 500 milliseconds
		this.timer = setTimeout(() => {
			this.$emit('input', this.searchTerm);
		}, 1000);
	},

	methods: {
		updateSearchTerm(term) {
			// Clear the previous timer
			if (this.timer) clearTimeout(this.timer);

			// Set a new timer to emit the input event after 500 milliseconds
			this.timer = setTimeout(() => {
				this.searchTerm = term;
				this.$emit('input', term);
			}, 1000);
		},

		resetSearchTerm() {
			this.updateSearchTerm('');
		}
	}
}
</script>
